module.exports = __webpack_public_path__ + "img/Banana.d501c2a8.svg";